import { useState } from 'react'

export default () => {
	const [listOpen, setListOpen] = useState(false)
	const [options, setOptions] = useState([])
	const [loading, setLoading] = useState(false)
	const [hasMore, setHasMore] = useState(false)
	const [cursor, setCursor] = useState(null)
	const [textInput, setTextInput] = useState('')
	return {
		listOpen,
		setListOpen,
		options,
		setOptions,
		loading,
		setLoading,
		hasMore,
		setHasMore,
		cursor,
		setCursor,
		textInput,
		setTextInput,
	}
}
